import {
  buildVeeraContextualAssistantMessage,
  buildVeeraContextualTopicDescriptor,
} from "../../supabase/functions/_shared/veeraContextualTopic.ts";

export { buildVeeraContextualAssistantMessage } from "../../supabase/functions/_shared/veeraContextualTopic.ts";

export interface VeeraContextualAssistantOpenerLike {
  carryOverSummary?: string | null;
  whyItMattersNow?: string | null;
  question?: string | null;
  shouldAskQuestion?: boolean;
}

interface VeeraContextualEntryLike {
  assistantOpener?: VeeraContextualAssistantOpenerLike | null;
}

export function getVeeraContextualOpenerSeed(params: {
  hasResolvedInitialMessages: boolean;
  messagesLength: number;
  conversationId?: string | null;
  sessionId?: string | null;
  seededConversationId?: string | null;
  contextualEntry?: unknown;
}) {
  if (!params.hasResolvedInitialMessages) return null;
  if (params.messagesLength > 0) return null;

  const conversationSeedKey = params.conversationId || params.sessionId;
  if (!conversationSeedKey) return null;
  if (params.seededConversationId === conversationSeedKey) return null;

  const contextualTopic = buildVeeraContextualTopicDescriptor(params.contextualEntry);
  const fallbackOpener = (params.contextualEntry as VeeraContextualEntryLike | null | undefined)?.assistantOpener ?? null;
  const assistantContent = buildVeeraContextualAssistantMessage(contextualTopic ?? fallbackOpener);
  if (!assistantContent) return null;

  return {
    conversationSeedKey,
    assistantContent,
  };
}
